import { createBaseResponseErrors } from '@/utils/error/responseErrors'
import { createBaseCRUDApi } from '@/api/baseApi'

const WAYBILL_URL = 'order/waybills'

const errors = createBaseResponseErrors('транспортную накладную', 'транспортных накладных')

export const WaybillApi = createBaseCRUDApi(WAYBILL_URL, errors)
